<div class="pinned">
  @if (canOthers) {
    <div class="person">
      <label class="small-label">{{ 'registration.person' | translate }}</label>
      <bst-list-adder [placeholder]="'enterusers' | translate" [listTemplate]="userlisttemplate" [autolist]="true" [formControl]="week.user"
                      [single]="true" size="small" status="basic" [filters]="{logo: true}" [target]="'member'"></bst-list-adder>
    </div>
  }
</div>

<bst-registration-approval-strip (changed)="reload()"></bst-registration-approval-strip>

@if (week.viewingOther && week.tripsAllowed) {
  <p class="readonly-notice"><nb-icon icon="eye-outline"></nb-icon>
    {{ 'registration.viewing_readonly' | translate:{name: week.user.value?.name} }}</p>
}
@if (week.tripsAllowed) {
  <bst-week-trips [weekStart]="week.weekStart" [userId]="week.user.value?.id || null" [locked]="week.locked"
                  [paging]="isLoading" (paged)="page($event)" (tripCount)="week.tripRows = $event"
                  (editing)="lockPerson($event)"></bst-week-trips>
} @else {
  <p class="readonly-notice">{{ 'registration.others_admin_only' | translate }}</p>
}

<ng-template #userlisttemplate let-result="result">
  <nb-user color="#eee" [name]="result.name" [picture]="logo(result)" size="small"></nb-user>
</ng-template>
